import { RouteConfig } from 'vue-router'
import { agencyDashboardRoutes } from '../constants/agency/'
import { requireAuth } from '../auth'

const AgencyDashboardRoot = () =>
import(
  /* webpackChunkName: "saas-dashboard" */ '@/pmd/pages/agencyDashboard/AgencyDashboardRoot.vue'
).then(m => m.default)

const AgencyDashboardMain = () =>
  import(
     /* webpackChunkName: "agency-dashboard" */ '@/pmd/pages/agencyDashboard/AgencyDashboardV2.vue'
  ).then(m => m.default)


export const dashboard: RouteConfig[] = [
  {
    path: '/agency_dashboard',
    name: agencyDashboardRoutes.default,
    component: AgencyDashboardRoot,
    beforeEnter: requireAuth,
    children: [
      {
        path: '',
        name: agencyDashboardRoutes.main,
        component: AgencyDashboardMain,
      },
    ],
  },
]

